exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-container[data-v-972e6e92]{background-color:#f2f2f2}.el-header[data-v-972e6e92]{padding:0}@media (min-width:992px){.el-main[data-v-972e6e92]{margin:auto 4rem}}", ""]);

// exports
